import { render, staticRenderFns } from "./total-revenue.card.vue?vue&type=template&id=52f0f369&"
import script from "./total-revenue.card.vue?vue&type=script&lang=js&"
export * from "./total-revenue.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports